<div class="login-body text-dark">
  <div class="login-wrapper">
    <div class="login-panel">
      <a [routerLink]="['/']" class="logo">
        <img
          src="assets/classjax-logo-dark.svg"
          alt="ClassJax Logo"
          class="img-fluid"
          style="width: 150px"
        />
      </a>

      <h2>Set a new password</h2>

      @if (success()) {
        <div class="login-form">
          <div class="alert alert-success" role="alert">
            Password updated. Redirecting&hellip;
          </div>
        </div>
      } @else {
        <form
          class="login-form"
          [formGroup]="form"
          (ngSubmit)="submit()"
          novalidate
          autocomplete="off"
        >
          @if (error(); as err) {
            <div class="alert alert-danger" role="alert">{{ err }}</div>
          }

          <div class="form-floating">
            <input
              type="password"
              class="form-control form-control-top"
              id="passwordField"
              placeholder="New password"
              autocomplete="new-password"
              formControlName="password"
            />
            <label for="passwordField" class="text-dark">New password</label>
          </div>
          <div class="form-floating">
            <input
              type="password"
              class="form-control form-control-bottom"
              id="confirmPasswordField"
              placeholder="Confirm password"
              autocomplete="new-password"
              formControlName="confirmPassword"
            />
            <label for="confirmPasswordField" class="text-dark">Confirm password</label>
          </div>

          @if (form.errors?.["mismatch"] && form.get("confirmPassword")?.touched) {
            <div class="alert alert-warning small" role="alert">
              Passwords do not match.
            </div>
          }

          <button
            type="submit"
            class="w-100 btn btn-lg btn-primary text-white"
            [class.fk-busy]="busy()"
            [disabled]="form.invalid || busy()"
          >
            UPDATE PASSWORD
          </button>

          <p class="mt-4">
            <a routerLink="/signin">Back to sign in</a>
          </p>
        </form>
      }
    </div>
  </div>
</div>
